import {
    IFormulaVisitor,
    IFormulaVisitorAsync
} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaVisitor';
import {FunctionName, FunctionNamespace} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';

export interface IFormulaNode
{
    acceptAsync(visitor:IFormulaVisitorAsync):Promise<any>;
    accept(visitor:IFormulaVisitor):void;
    toString():string;
}

export enum BinaryOpType
{
    Add = '+',
    Subtract = '-',
    Divide = '/',
    Multiply = '*',
    Power = '^'
}

export enum CompareOpType
{
    Lt = '<',
    Gt = '>',
    Equal = '=',
    NotEqual = '<>',
    Le = '<=',
    Ge = '>=',
}

export enum CellOpType
{
    Union = '|',
    Intersection = '{space}',
    Range = ':',
    List = ',',
}

export class FunctionNameLiteral
{
    constructor(public readonly namespace:FunctionNamespace,
                public readonly name:FunctionName)
    {
    }

    toString()
    {
        return `FunctionNameLiteral: ${this.namespace}.${this.name}`;
    }
}
